import { h } from 'preact'
import { replaceFilter, tagParser } from '../../js/modules/utilities.js'

export const BandeEcommerce = ({ background = 'white', title, items, cacheKey }) => {
   return (
      <div
         id="zone_reassurance_e-boutique"
         class={`${background === 'grey' ? 'bg-gray2' : ''} reassurance-ecommerce pb-2 pb-md-4`}
         data-testid="bande-reassurance-ecommerce"
         data-cache-key={cacheKey}
      >
         <div class="container-fluid">
            {dataStoreHP.pageId !== 'hp' && <h2 class="h3 block-title no-signature mb-1">{tagParser(replaceFilter(title))}</h2>}
            <ul class="reassurance-ecommerce-list">
               {items.map((item, index) => {
                  return (
                     <li>
                        <a
                           class="reassurance-ecommerce-link"
                           href={item.URL}
                           data-testid={`reassurance-ecommerce${index + 1}`}
                           data-pdb-zid={item.analytics.pdbZid}
                           data-pdb-sc={item.analytics.pdbSc}
                           data-pdb-idc={item.analytics.pdbIdc}
                           data-pdb-vi={item.analytics.pdbVi}
                           data-oevent-category={item.analytics.oeventCategory}
                           data-oevent-action={item.analytics.oeventAction}
                           data-oevent-label={item.analytics.oeventLabel}
                           data-oevent-other={item.analytics.oeventOther}
                        >
                           <img class="hpicon" src={`${item.image}?format=x90`} height="45" width="45" alt="" loading="lazy" />
                           <span class="reassurance-ecommerce-label o-link-arrow" dangerouslySetInnerHTML={{ __html: tagParser(replaceFilter(item.title)) }}></span>
                        </a>
                     </li>
                  )
               })}
            </ul>
         </div>
      </div>
   )
}
